(ns app.front.view.admin.migration.migrate-workspace-address-units
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/migrate-workspace-address-units
    :title     "Migrate workspace address units"
    :help-text (str "This migration cleans up workspace addresses, removing their unit information. "
                    "'Migrate property units' must be run first.")}
   match])

(def route
  {:name        :view/admin.migration.migrate-workspace-address-units
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/migrate-workspace-address-units]))}]})

(defn revert-view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/revert-migrate-workspace-address-units
    :title     "Revert workspace address unit migration"
    :help-text (str "This task reverses every transaction created by 'Migrate workspace address units', newest first. "
                    "Run this task before reverting the property unit migration. "
                    "Do not run either forward migration while this task is in progress.")}
   match])

(def revert-route
  {:name        :view/admin.migration.revert-migrate-workspace-address-units
   :view        revert-view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/revert-migrate-workspace-address-units]))}]})
